import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';

import { Popover } from '../../../../../modules/modules';
import CountryService from '../../../../../services/CountryService';
import AuthService from '../../../../../services/AuthService';
import { callAuthorizeBackend } from '../../../../../helpers/backend/callAuthorizeBackend';
import { useAuth0 } from '@auth0/auth0-react';

interface INotLoggedProps extends RouteComponentProps {
  isOpened: boolean;
  toggleOpen: () => void;
  refetch: () => void;
}

const LoggedIn = (props: INotLoggedProps) => {
  const { logout } = useAuth0();
  const { countryCode, currencyCodePageParam } = CountryService.GetInstance();
  const auth = AuthService.GetInstance();

  const { customer } = auth;

  let customerSections: any[] = [];
  const customerGroups = (customer && customer.customerGroups);
  if (customerGroups) {
    customerSections = customerGroups.filter((cg: any) => !!cg.description);
  }

  return (
    <>
      <Popover type="userPopup">
        <p className="header__userActions__action" onClick={() => props.toggleOpen()}>
          {customer && customer.invoiceFirstName && customer.invoiceLastName
            ? `${customer.invoiceFirstName} ${customer.invoiceLastName}`
            : 'My account'}
        </p>
        <div className="nav__drop nav__drop--userPopup">
          {/* Country code urls are not used anymore
          <Link to={`/${countryCode}/user/orders`} className="nav__item"> */}
          <Link to={`/user/orders`} className="nav__item">
            My orders
          </Link>
          {/* Country code urls are not used anymore
          <Link to={`/${countryCode}/user/data`} className="nav__item"> */}
          <Link to={`/user/data`} className="nav__item">
            Personal data
          </Link>
          {/* Country code urls are not used anymore
          <Link to={`/${countryCode}/user/password`} className="nav__item"> */}
          <Link to={`/user/password`} className="nav__item">
            Change password
          </Link>
          {auth.customer && auth.customer.discount &&
            (<>
              <Link to={`/${countryCode}/user/export-pricelist`} /* onClick={handleDownloadB2BPricelist} */ className="nav__item">
                Download pricelist
              </Link>
              <a href="https://divesoft.com/brandbook" original-href="https://api.divesoft.eu/resources/static/brandbook.pdf" target="_brandbook" className="nav__item">
                Download brandbook
              </a>
            </>) || ''
          }
          {customerSections && customerSections.map((customerGroup: any) => ( 
            <Link to={`/user/group/${customerGroup.id}`} className="nav__item">
            {/* Country code urls are not used anymore
            <Link to={`/${countryCode}/user/group/${customerGroup.id}`} className="nav__item"> */}
              {customerGroup.name}
            </Link>))}
          <Link
            onClick={() => {
              AuthService.GetInstance().removeToken();
              // FlashStore.GetInstance().showMessage(
              //   'Uživatel byl odhlášen',
              //   'success'
              // );
              logout({ returnTo: `${window.location.origin}${currencyCodePageParam ? `?currency=${currencyCodePageParam}` : ''}` });
              props.refetch();
              props.toggleOpen();

            }}
            // Country code urls are not used anymore
            // to={`/${countryCode}`}
            to={`/`}
            className="nav__item"
          >
            Logout
          </Link>
        </div>
      </Popover>
    </>
  );
};

export const handleDownloadB2BPricelist = () => {
  const currency = CountryService.GetInstance().currency;
  // volání backendu
  callAuthorizeBackend({
    path: '/products/pricelist/b2b',
    data: {
      currency: currency && currency.value,
    },
    method: 'POST',
    executeDownload: true,
  });
};

export default withRouter(LoggedIn);


// WEBPACK FOOTER //
// ./src/components/Header/components/Account/components/Logged.tsx